import styled from 'styled-components';
import { rem, ellipsis } from 'polished';
import noNotificationsImage from '../../../../../assets/images/png/noNotifications.png';

const StyledWidgetNotifications = styled.div`
  width: auto;

  .title {
    color: ${props => props.theme.colors.light};
    font-family: ${props => props.theme.fonts.book};
    font-size: ${rem('17px')};
    text-transform: uppercase;
    margin-top: ${rem('5px')};
    margin-bottom: ${rem('30px')};
    line-height: ${rem('20px')};
    display: flex;
    align-items: center;
  }
  span.Notificaciones{
    display: none;
  }
  span.notificaciones.generales, span.NOTIFICACIONES.PAQUETERÍA{
    display: block;
  }
  .icon-title {
    width: ${rem('17px')};
    fill: ${props => props.theme.colors.light};
    margin-right: ${rem('7px')};
  }
  .txtNoNotifications {
    color: ${props => props.theme.colors.light};
    font-family: ${props => props.theme.fonts.book};
    font-size: ${rem('16px')};
    background: url('${noNotificationsImage}') no-repeat 0 ${rem('64px')};
    padding: 0 0 ${rem('260px')} ${rem('15px')};
    position: relative;
    left: ${rem('-15px')};
  }
  .appNotifications-iconNot, .notification-collapse{
    display: none;
  }
  .notification-box{
    background-color: transparent;
    box-shadow: none;
    position: static;
    width: auto;
    height: auto;
    margin: 0;
    &:after{ content: none; }
    padding-top: 0;
    max-height: ${rem('500px')};
  }
  .notification-title-box{
    border: none;
    margin-left: 0;
  }
  .notification {
    background-color: rgba(255, 255, 255, 0.92);
    padding: ${rem('25px')} ${rem('15px')};
    display: flex;
    margin-bottom: ${rem('15px')};
    position: relative;

  
    .notification-icon {
      width: ${rem('20px')};
      height: ${rem('20px')};
      fill: ${props => props.theme.colors.grayDarkest};
      margin-bottom: ${rem('7px')};
    }
    .notification-date {
      color: ${props => props.theme.colors.grayDarkest};
      font-family: ${props => props.theme.fonts.medium};
      font-size: ${rem('14px')};
    }
    .notification-title {
      color: ${props => props.theme.colors.grayDarkest};
      font-family: ${props => props.theme.fonts.medium};
      font-size: ${rem('14px')};
      line-height: ${rem('17px')};
      text-transform: none;
      white-space: inherit;
      overflow: visible;
      text-overflow: clip;
      width: ${rem('256px')};
      display: block;
      max-height: inherit;
      margin-bottom: ${rem('5px')};
      max-width: ${rem('200px')};
      ${ellipsis('142px')};
    }
    .notification-description {
      color: ${props => props.theme.colors.grayDarkest};
      font-family: ${props => props.theme.fonts.book};
      font-size: ${rem('14px')};
      line-height: ${rem('17px')};
      margin-bottom: ${rem('5px')};
      max-height: inherit;
      white-space: inherit;
      overflow: visible;
      text-overflow: clip;
    }
    .notification-creator {
       color: ${props => props.theme.colors.grayDarkest};
    }
    .notification-box {
      align-items: center;
      background-color: ${props => props.theme.colors.primary};
      flex-flow: wrap column;
      height: 100%;
      justify-content: center;
      left: 100%;
      top: 0;
      position: absolute;
      transition: all 0.25s ease-in-out 0.2s;
      width: 100%;
      z-index: 2;
      display: flex;
    }
    &:hover,
    &:focus {
      .notification-box {
        display: flex;
        left: 0;
      }
    }
  }
  .btn-type-notification{
    padding-left: ${rem('5px')};
  }
  .widget-hide{
    display: none;
  }
`;

export { StyledWidgetNotifications };
